import {
  getInsuranceData,
  getInsurantData,
  getQuotation,
  getIsOperatorFromSelector,
  setMessageVisibility,
} from 'app/services/businessFunctionHelpers';
import { MessagesEnum, FormsEnum } from 'app/shared/enums';
import { checkIsDataObfuscated } from 'app/services/businessFunctions/helpers/checkIsDataObfuscated';
import { handleObfuscatedFieldConsentReset } from 'app/services/businessFunctions/helpers/handleObfuscatedFieldConsentReset';

const insurantObfuscation = {
  showInsurancePhoneNumberObfuscatedMessage(initialRun?: boolean) {
    const { phoneNumber } = getInsuranceData();
    const quotation = getQuotation();
    const isOperator = getIsOperatorFromSelector();

    handleObfuscatedFieldConsentReset({
      value: phoneNumber || '',
      initialRun,
      messageKey: MessagesEnum.InsurancePhoneNumberObfuscated,
      formName: FormsEnum.CalculationForm,
      quotation,
      isOperator,
      resetTarget: {
        type: 'root',
        field: 'phoneNumber',
      },
    });
  },
  showInsurantNipNumberObfuscatedMessage(initialRun?: boolean) {
    const { nip } = getInsurantData();

    const showObfuscatedMessage = checkIsDataObfuscated(nip, initialRun);

    setMessageVisibility({
      key: MessagesEnum.InsurantNipNumberObfuscated,
      visible: showObfuscatedMessage,
      formName: FormsEnum.CalculationForm,
    });
  },
  showCalculationInsurantEmailObfuscatedMessage(initialRun?: boolean) {
    const { email } = getInsurantData();
    const quotation = getQuotation();
    const isOperator = getIsOperatorFromSelector();

    handleObfuscatedFieldConsentReset({
      value: email || '',
      initialRun,
      messageKey: MessagesEnum.CalculationInsurantEmailObfuscated,
      formName: FormsEnum.CalculationForm,
      quotation,
      isOperator,
      resetTarget: {
        type: 'root',
        field: 'email',
      },
    });
  },
};

export default insurantObfuscation;
